import { render, staticRenderFns } from "./auth.vue?vue&type=template&id=05510b0f&scoped=true"
var script = {}
import style0 from "./auth.vue?vue&type=style&index=0&id=05510b0f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05510b0f",
  null
  
)

export default component.exports